module.exports = __webpack_public_path__ + "img/3.4519d07a.jpg";